import React from 'react'
import propTypes from 'prop-types'
import { Popper, ClickAwayListener, Paper, makeStyles } from '@material-ui/core'
import BaseConfiguration from './BaseConfigurator'

const useStyles = makeStyles((theme) => ({
	/**
	 * Popper stacks at the page's own level unless told otherwise, and the application bar sits
	 * at 1100, so the configurator opened underneath it -- visibly, since the bar is opaque and
	 * the popper hangs off a control near the top of the page.
	 *
	 * Raised to the drawer's level rather than to an invented number, so it keeps its place in
	 * the theme's order: above the bar it escapes, and still below modals and snackbars, which
	 * should cover it when they appear.
	 */
	popper: {
		zIndex: theme.zIndex.drawer
	}
}))

/**
 * A data grid configurator contained in a popper
 */
const PopperConfigurator = (props) => {
	const { open, anchorEl, placement } = props
	const classes = useStyles()
	return (
		<Popper open={open} anchorEl={anchorEl} placement={placement} className={classes.popper}>
			<ClickAwayListener onClickAway={props.onClickAway}>
				<Paper>
					<BaseConfiguration {...props}  />
				</Paper>
			</ClickAwayListener>
		</Popper>
	)
}
PopperConfigurator.propTypes = {
	/**
	 *  It's used to set the position of the popper. The return value will passed as the reference object of the Popper instance.
	 */
	anchorEl: propTypes.object,
	/**
	 * If true, the popper is visible.
	 */
	open: propTypes.bool.isRequired,
	/**
	 * Callback executed when the user clicks away from the popper
	 */
	onClickAway: propTypes.func.isRequired,
	/**
	 * The placement of the popper relative to the anchorel
	 */
	placement: propTypes.oneOf([
		'bottom-end',
		'bottom-start',
		'bottom',
		'left-end',
		'left-start',
		'left',
		'right-end',
		'right-start',
		'right',
		'top-end',
		'top-start',
		'top'
	]),
	/**
	 * The table configuration with visible and index properties
	 */
	configuration: propTypes.arrayOf(
		propTypes.shape({
			title: propTypes.string.isRequired,
			visible: propTypes.bool.isRequired
		})
	).isRequired,
	/**
	 * Callback executed when the user save the configuration
	 */
	onConfigurationChange: propTypes.func.isRequired,
	/**
	 * The max height of the columns configuration container
	 */
	maxHeight: propTypes.string
}
PopperConfigurator.defaultProps = {
	open: false,
	placement: 'bottom',
	maxHeight: '300px'
}
export default PopperConfigurator